// extracted by mini-css-extract-plugin
module.exports = {"container":"confirmDialog_container__1bTEE","title":"confirmDialog_title__1Nfpi","content":"confirmDialog_content__1b1Tk","actions":"confirmDialog_actions__3gXRF"};